export const V3IconBranding = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
        <path stroke="#ABB0BA" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M2 14v-2.667A2.667 2.667 0 1 1 4.667 14H2Z" />
        <path
            stroke="#ABB0BA"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M14 2a10.667 10.667 0 0 0-8.533 6.8M14 2a10.667 10.667 0 0 1-6.8 8.533"
        />
        <path stroke="#ABB0BA" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M7.067 6A6 6 0 0 1 10 8.933" />
    </svg>
);
